import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
var AmdSidenavService = /** @class */ (function () {
    function AmdSidenavService() {
        this.sidenavToggledSource = new Subject();
        this.sidenavOpenedSource = new Subject();
        this.sidenavClosedSource = new Subject();
        this.sidenavToggled = this.sidenavToggledSource.asObservable();
        this.sidenavOpened = this.sidenavOpenedSource.asObservable();
        this.sidenavClosed = this.sidenavClosedSource.asObservable();
    }
    /**
     * @param {?} sidenavId
     * @return {?}
     */
    AmdSidenavService.prototype.toggle = function (sidenavId) {
        this.sidenavToggledSource.next(sidenavId);
    };
    /**
     * @param {?} sidenavId
     * @return {?}
     */
    AmdSidenavService.prototype.open = function (sidenavId) {
        this.sidenavOpenedSource.next(sidenavId);
    };
    /**
     * @param {?} sidenavId
     * @return {?}
     */
    AmdSidenavService.prototype.close = function (sidenavId) {
        this.sidenavClosedSource.next(sidenavId);
    };
    AmdSidenavService.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    AmdSidenavService.ctorParameters = function () { return []; };
    return AmdSidenavService;
}());
export { AmdSidenavService };
function AmdSidenavService_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSidenavService.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSidenavService.ctorParameters;
    /** @type {?} */
    AmdSidenavService.prototype.sidenavToggled;
    /** @type {?} */
    AmdSidenavService.prototype.sidenavOpened;
    /** @type {?} */
    AmdSidenavService.prototype.sidenavClosed;
    /** @type {?} */
    AmdSidenavService.prototype.sidenavToggledSource;
    /** @type {?} */
    AmdSidenavService.prototype.sidenavOpenedSource;
    /** @type {?} */
    AmdSidenavService.prototype.sidenavClosedSource;
}
//# sourceMappingURL=sidenav.service.js.map
//# sourceMappingURL=sidenav.service.js.map
